import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'html',
  standalone: false,
})
export class HtmlPipe implements PipeTransform {

  constructor(
    protected sanitizer: DomSanitizer
  ) { }

  transform(value: string): SafeHtml {
    let replacedHtml = '';
    if (!!value) {
      replacedHtml = value.replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
      replacedHtml = replacedHtml.replace(/\n|\r|\r\n/g, '<br>').replace(/\s+/g, '&nbsp;');
    }
    return this.sanitizer.bypassSecurityTrustHtml(replacedHtml);
  }

}
